export const CONTACT_EMAILS = {
    billing: 'billing@countercyclical.io',
    engineering: 'engineering@countercyclical.io',
    enterprise: 'enterprise@countercyclical.io',
    security: 'security@countercyclical.io',
    support: 'support@countercyclical.io',
} as const;

export const EMAIL_LINKS = {
    billing: `mailto:${CONTACT_EMAILS.billing}`,
    engineering: `mailto:${CONTACT_EMAILS.engineering}`,
    enterprise: `mailto:${CONTACT_EMAILS.enterprise}`,
    enterpriseBilling: `mailto:${CONTACT_EMAILS.enterprise}?subject=Enterprise%20Billing`,
    security: `mailto:${CONTACT_EMAILS.security}`,
    support: `mailto:${CONTACT_EMAILS.support}`,
} as const;

export const EXTERNAL_LINKS = {
    documentation: {
        home: 'https://docs.countercyclical.io',
    },
    dub: {
        home: 'https://dub.co',
        partnerPrograms: 'https://partners.dub.co/programs',
        payouts: 'https://partners.dub.co/payouts',
    },
    notionForms: {
        feedback: {
            href: 'https://countercyclical.notion.site/ebd//3a350036d086808694f4efe415ba2d5b',
            title: 'Share Feedback',
            iframeTitle: 'Countercyclical feedback form',
        },
        support: {
            href: 'https://countercyclical.notion.site/ebd//3a350036d086808694f4efe415ba2d5b',
            title: 'Contact Support',
            iframeTitle: 'Countercyclical support form',
        },
    },
} as const;

export const NOTION_FORMS = EXTERNAL_LINKS.notionForms;

export type NotionFormKind = keyof typeof NOTION_FORMS;
